"use strict";
"use client";

var _toConsumableArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// packages/react/roving-focus/src/index.ts
var src_exports = {};
__export(src_exports, {
  Item: function Item() {
    return _Item;
  },
  Root: function Root() {
    return _Root;
  },
  RovingFocusGroup: function RovingFocusGroup() {
    return _RovingFocusGroup;
  },
  RovingFocusGroupItem: function RovingFocusGroupItem() {
    return _RovingFocusGroupItem;
  },
  createRovingFocusGroupScope: function createRovingFocusGroupScope() {
    return _createRovingFocusGroupScope;
  }
});
module.exports = __toCommonJS(src_exports);

// packages/react/roving-focus/src/RovingFocusGroup.tsx
var React = __toESM(require("react"));
var import_primitive = require("@radix-ui/primitive");
var import_react_collection = require("@radix-ui/react-collection");
var import_react_compose_refs = require("@radix-ui/react-compose-refs");
var import_react_context = require("@radix-ui/react-context");
var import_react_id = require("@radix-ui/react-id");
var import_react_primitive = require("@radix-ui/react-primitive");
var import_react_use_callback_ref = require("@radix-ui/react-use-callback-ref");
var import_react_use_controllable_state = require("@radix-ui/react-use-controllable-state");
var import_react_direction = require("@radix-ui/react-direction");
var import_jsx_runtime = require("react/jsx-runtime");
var ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
var EVENT_OPTIONS = {
  bubbles: false,
  cancelable: true
};
var GROUP_NAME = "RovingFocusGroup";
var _ref = (0, import_react_collection.createCollection)(GROUP_NAME),
  _ref2 = _slicedToArray(_ref, 3),
  Collection = _ref2[0],
  useCollection = _ref2[1],
  createCollectionScope = _ref2[2];
var _ref3 = (0, import_react_context.createContextScope)(GROUP_NAME, [createCollectionScope]),
  _ref4 = _slicedToArray(_ref3, 2),
  createRovingFocusGroupContext = _ref4[0],
  _createRovingFocusGroupScope = _ref4[1];
var _createRovingFocusGro = createRovingFocusGroupContext(GROUP_NAME),
  _createRovingFocusGro2 = _slicedToArray(_createRovingFocusGro, 2),
  RovingFocusProvider = _createRovingFocusGro2[0],
  useRovingFocusContext = _createRovingFocusGro2[1];
var _RovingFocusGroup = React.forwardRef(function (props, forwardedRef) {
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(Collection.Provider, {
    scope: props.__scopeRovingFocusGroup,
    children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(Collection.Slot, {
      scope: props.__scopeRovingFocusGroup,
      children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(RovingFocusGroupImpl, _objectSpread({}, props, {
        ref: forwardedRef
      }))
    })
  });
});
_RovingFocusGroup.displayName = GROUP_NAME;
var RovingFocusGroupImpl = React.forwardRef(function (props, forwardedRef) {
  var __scopeRovingFocusGroup = props.__scopeRovingFocusGroup,
    orientation = props.orientation,
    _props$loop = props.loop,
    loop = _props$loop === void 0 ? false : _props$loop,
    dir = props.dir,
    currentTabStopIdProp = props.currentTabStopId,
    defaultCurrentTabStopId = props.defaultCurrentTabStopId,
    onCurrentTabStopIdChange = props.onCurrentTabStopIdChange,
    onEntryFocus = props.onEntryFocus,
    _props$preventScrollO = props.preventScrollOnEntryFocus,
    preventScrollOnEntryFocus = _props$preventScrollO === void 0 ? false : _props$preventScrollO,
    groupProps = _objectWithoutProperties(props, ["__scopeRovingFocusGroup", "orientation", "loop", "dir", "currentTabStopId", "defaultCurrentTabStopId", "onCurrentTabStopIdChange", "onEntryFocus", "preventScrollOnEntryFocus"]);
  var ref = React.useRef(null);
  var composedRefs = (0, import_react_compose_refs.useComposedRefs)(forwardedRef, ref);
  var direction = (0, import_react_direction.useDirection)(dir);
  var _ref5 = (0, import_react_use_controllable_state.useControllableState)({
      prop: currentTabStopIdProp,
      defaultProp: defaultCurrentTabStopId,
      onChange: onCurrentTabStopIdChange
    }),
    _ref6 = _slicedToArray(_ref5, 2),
    _ref6$ = _ref6[0],
    currentTabStopId = _ref6$ === void 0 ? null : _ref6$,
    setCurrentTabStopId = _ref6[1];
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isTabbingBackOut = _React$useState2[0],
    setIsTabbingBackOut = _React$useState2[1];
  var handleEntryFocus = (0, import_react_use_callback_ref.useCallbackRef)(onEntryFocus);
  var getItems = useCollection(__scopeRovingFocusGroup);
  var isClickFocusRef = React.useRef(false);
  var _React$useState3 = React.useState(0),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    focusableItemsCount = _React$useState4[0],
    setFocusableItemsCount = _React$useState4[1];
  React.useEffect(function () {
    var node = ref.current;
    if (node) {
      node.addEventListener(ENTRY_FOCUS, handleEntryFocus);
      return function () {
        return node.removeEventListener(ENTRY_FOCUS, handleEntryFocus);
      };
    }
  }, [handleEntryFocus]);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(RovingFocusProvider, {
    scope: __scopeRovingFocusGroup,
    orientation: orientation,
    dir: direction,
    loop: loop,
    currentTabStopId: currentTabStopId,
    onItemFocus: React.useCallback(function (tabStopId) {
      return setCurrentTabStopId(tabStopId);
    }, [setCurrentTabStopId]),
    onItemShiftTab: React.useCallback(function () {
      return setIsTabbingBackOut(true);
    }, []),
    onFocusableItemAdd: React.useCallback(function () {
      return setFocusableItemsCount(function (prevCount) {
        return prevCount + 1;
      });
    }, []),
    onFocusableItemRemove: React.useCallback(function () {
      return setFocusableItemsCount(function (prevCount) {
        return prevCount - 1;
      });
    }, []),
    children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_react_primitive.Primitive.div, _objectSpread({
      tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
      "data-orientation": orientation
    }, groupProps, {
      ref: composedRefs,
      style: _objectSpread({
        outline: "none"
      }, props.style),
      onMouseDown: (0, import_primitive.composeEventHandlers)(props.onMouseDown, function () {
        isClickFocusRef.current = true;
      }),
      onFocus: (0, import_primitive.composeEventHandlers)(props.onFocus, function (event) {
        var isKeyboardFocus = !isClickFocusRef.current;
        if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
          var entryFocusEvent = new CustomEvent(ENTRY_FOCUS, EVENT_OPTIONS);
          event.currentTarget.dispatchEvent(entryFocusEvent);
          if (!entryFocusEvent.defaultPrevented) {
            var items = getItems().filter(function (item) {
              return item.focusable;
            });
            var activeItem = items.find(function (item) {
              return item.active;
            });
            var currentItem = items.find(function (item) {
              return item.id === currentTabStopId;
            });
            var candidateItems = [activeItem, currentItem].concat(_toConsumableArray(items)).filter(Boolean);
            var candidateNodes = candidateItems.map(function (item) {
              return item.ref.current;
            });
            focusFirst(candidateNodes, preventScrollOnEntryFocus);
          }
        }
        isClickFocusRef.current = false;
      }),
      onBlur: (0, import_primitive.composeEventHandlers)(props.onBlur, function () {
        return setIsTabbingBackOut(false);
      })
    }))
  });
});
var ITEM_NAME = "RovingFocusGroupItem";
var _RovingFocusGroupItem = React.forwardRef(function (props, forwardedRef) {
  var __scopeRovingFocusGroup = props.__scopeRovingFocusGroup,
    _props$focusable = props.focusable,
    focusable = _props$focusable === void 0 ? true : _props$focusable,
    _props$active = props.active,
    active = _props$active === void 0 ? false : _props$active,
    tabStopId = props.tabStopId,
    itemProps = _objectWithoutProperties(props, ["__scopeRovingFocusGroup", "focusable", "active", "tabStopId"]);
  var autoId = (0, import_react_id.useId)();
  var id = tabStopId || autoId;
  var context = useRovingFocusContext(ITEM_NAME, __scopeRovingFocusGroup);
  var isCurrentTabStop = context.currentTabStopId === id;
  var getItems = useCollection(__scopeRovingFocusGroup);
  var onFocusableItemAdd = context.onFocusableItemAdd,
    onFocusableItemRemove = context.onFocusableItemRemove;
  React.useEffect(function () {
    if (focusable) {
      onFocusableItemAdd();
      return function () {
        return onFocusableItemRemove();
      };
    }
  }, [focusable, onFocusableItemAdd, onFocusableItemRemove]);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(Collection.ItemSlot, {
    scope: __scopeRovingFocusGroup,
    id: id,
    focusable: focusable,
    active: active,
    children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_react_primitive.Primitive.span, _objectSpread({
      tabIndex: isCurrentTabStop ? 0 : -1,
      "data-orientation": context.orientation
    }, itemProps, {
      ref: forwardedRef,
      onMouseDown: (0, import_primitive.composeEventHandlers)(props.onMouseDown, function (event) {
        if (!focusable) event.preventDefault();else context.onItemFocus(id);
      }),
      onFocus: (0, import_primitive.composeEventHandlers)(props.onFocus, function () {
        return context.onItemFocus(id);
      }),
      onKeyDown: (0, import_primitive.composeEventHandlers)(props.onKeyDown, function (event) {
        if (event.key === "Tab" && event.shiftKey) {
          context.onItemShiftTab();
          return;
        }
        if (event.target !== event.currentTarget) return;
        var focusIntent = getFocusIntent(event, context.orientation, context.dir);
        if (focusIntent !== void 0) {
          if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
          event.preventDefault();
          var items = getItems().filter(function (item) {
            return item.focusable;
          });
          var candidateNodes = items.map(function (item) {
            return item.ref.current;
          });
          if (focusIntent === "last") candidateNodes.reverse();else if (focusIntent === "prev" || focusIntent === "next") {
            if (focusIntent === "prev") candidateNodes.reverse();
            var currentIndex = candidateNodes.indexOf(event.currentTarget);
            candidateNodes = context.loop ? wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
          }
          setTimeout(function () {
            return focusFirst(candidateNodes);
          });
        }
      })
    }))
  });
});
_RovingFocusGroupItem.displayName = ITEM_NAME;
var MAP_KEY_TO_FOCUS_INTENT = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function getDirectionAwareKey(key, dir) {
  if (dir !== "rtl") return key;
  return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function getFocusIntent(event, orientation, dir) {
  var key = getDirectionAwareKey(event.key, dir);
  if (orientation === "vertical" && ["ArrowLeft", "ArrowRight"].includes(key)) return void 0;
  if (orientation === "horizontal" && ["ArrowUp", "ArrowDown"].includes(key)) return void 0;
  return MAP_KEY_TO_FOCUS_INTENT[key];
}
function focusFirst(candidates) {
  var preventScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
  var _iterator2 = _createForOfIteratorHelper(candidates),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var candidate = _step2.value;
      if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
      candidate.focus({
        preventScroll: preventScroll
      });
      if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
}
function wrapArray(array, startIndex) {
  return array.map(function (_, index) {
    return array[(startIndex + index) % array.length];
  });
}
var _Root = _RovingFocusGroup;
var _Item = _RovingFocusGroupItem;